/**
 * 访客接口
 */

import { baseURL } from '@/api/base' // 导入接口域名列表
//
import axios from '@/utils/http' // 导入http中创建的axios实例

// 系统名称
export const getSysName: () => Promise<{ sctName: string }> = function () {
	return axios.get(`${baseURL}/api/getSysName`, { hideLoading: true })
}

export type BeianInfo = Record<'banquanContent' | 'beianContent' | 'beianUrl' | 'icpContent' | 'icpUrl', string>
// 获取备案信息
export const getBeiAnInfo: () => Promise<BeianInfo> = function () {
	return axios.get(`${baseURL}/api/vis/sys/getSysInfo`, { hideLoading: true })
}

export default {
	getSysName,
	getBeiAnInfo,
}
